import { useMemo } from 'react';
import { useI18n } from '../../../hooks/useI18n';
import type { AiTranslatorProfile } from '../api/types';

export function useAiTranslatorProfilesColumns() {
    const { t } = useI18n();

    const availableColumns = useMemo<any[]>(() => [
        {
            key: 'name',
            label: t('common.name'),
            sortable: true,
            visible: true,
            render: (_value: any, profile: AiTranslatorProfile) => (
                <div>
                    <div className="font-medium text-foreground">{profile.name}</div>
                    {profile.description && (
                        <div className="text-xs text-muted-foreground truncate max-w-xs">
                            {profile.description}
                        </div>
                    )}
                </div>
            )
        },
        {
            key: 'nativeLanguage',
            label: 'Native Language',
            sortable: true,
            visible: true,
            render: (_value: any, profile: AiTranslatorProfile) => (
                <div className="flex items-center gap-2">
                    <span className="px-2 py-0.5 text-xs rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400 border border-blue-200 dark:border-blue-800">
                        {profile.nativeLanguage?.toUpperCase() || 'EN'}
                    </span>
                </div>
            )
        },
        {
            key: 'voice',
            label: 'Local Voice',
            sortable: true,
            visible: true,
            render: (_value: any, profile: AiTranslatorProfile) => (
                <span className="text-sm text-foreground capitalize">{profile.voice || '—'}</span>
            )
        },
        {
            key: 'remoteVoice',
            label: 'Remote Voice',
            sortable: true,
            visible: true,
            render: (_value: any, profile: AiTranslatorProfile) => (
                <span className="text-sm text-foreground capitalize">{profile.remoteVoice || '—'}</span>
            )
        },
        {
            key: 'enabled',
            label: t('common.statusText'),
            sortable: true,
            visible: true,
            render: (_value: any, profile: AiTranslatorProfile) => (
                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
                    profile.enabled
                        ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'
                        : 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400'
                }`}>
                    {profile.enabled ? t('common.enabled') : t('common.disabled')}
                </span>
            )
        },
        {
            key: 'actions',
            label: t('common.actions') || 'Actions',
            sortable: false,
            visible: true,
            width: '100px',
            align: 'right'
        }
    ], [t]);

    return { availableColumns };
}
